import { pdf } from "@react-pdf/renderer"
import RcmpHeader from "../../../../atoms/Header"
import ContentBlank from "../../../../molecules/ContentBlank"
import RcmpLoading from "../../../../atoms/Loading"
import intl from "react-intl-universal"
import IconCiq from "../../../../../assets/icons/CIQIcon"
import { useEffect, useState } from "react"
import styles from "./index.module.scss"
import { ReportFilters } from "./components/ReportFilters"
import {
  getAllEquipments,
  getAnaliteByEquipment,
  generateReport,
} from "../../../../../services/ciq"
import { toast } from "@stardust-ds/react"
import Button from "../../../../atoms/Button"

import ProcessChartAndTableToImage from "./components/ProcessChartAndTableToImage"
import CiqReportPdf from "./components/CiqReportPdf"

const Reports = () => {
  const [equipments, setEquipments] = useState([])
  const [oAnalyteSelected, setOAnalyteSelected] = useState([])
  const [oEquipmentSelected, setOEquipmentSelected] = useState([])
  const [analytes, setAnalytes] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [startDate, setStartDate] = useState(dataTrintaDiasAtras())
  const [endDate, setEndDate] = useState(new Date().toISOString().split("T")[0])
  const [status, setStatus] = useState({})
  const [isLoadingAnalyte, setIsLoadingAnalyte] = useState(false)
  const [isLoadingGenerateReport, setIsLoadingGenerateReport] = useState(false)
  const [bIsGeneratingPdf, setBIsGeneratingPdf] = useState(false)
  const [generetedReport, setGeneratedReport] = useState([])
  const [processedReport, setProcessedReport] = useState([])

  const [aBreadcrumb, setABreadcrumb] = useState([
    {
      path: "./",
      name: intl.get("home"),
    },
    {
      path: "/ciq",
      name: intl.get("ciq.title"),
      bActive: true,
    },
  ])

  const getEquipments = async () => {
    try {
      setIsLoading(true)
      const response = await getAllEquipments()
      const data = response?.data?.data?.map((item) => ({
        label: item.equipment_cname,
        value: item.equipment_nid,
      }))

      setEquipments(data)
    } catch (err) {
      toast({
        type: "error",
        description: intl.get("ciqReport.error_to_load_equipments"),
      })
    } finally {
      setIsLoading(false)
    }
  }

  const getAnalyteLinkedEquipment = async (equipmentId) => {
    try {
      setIsLoadingAnalyte(true)
      const response = await getAnaliteByEquipment(equipmentId)
      const data = response?.data?.data?.map((item) => ({
        label: item?.anlt_cname,
        value: item?.anlt_nid,
      }))

      setAnalytes(data || [])
    } catch (err) {
      toast({
        type: "error",
        description: intl.get("ciqReport.error_to_load_analaytes"),
      })
    } finally {
      setIsLoadingAnalyte(false)
    }
  }

  const getReport = async (oParams) => {
    try {
      setBIsGeneratingPdf(false)
      setGeneratedReport([])
      setProcessedReport([])
      setIsLoadingGenerateReport(true)
      const response = await generateReport(oParams)
      setGeneratedReport(response?.data?.data)
    } catch (err) {
      toast({
        type: "error",
        description: intl.get("ciqReport.error_to_load_data"),
      })
      setIsLoadingGenerateReport(false)
    }
  }

  useEffect(() => {
    if (!generetedReport || bIsGeneratingPdf || !processedReport) return

    const nTotalAnalytes = generetedReport.equipment?.flatMap(
      (eqp) => eqp.equipment_analytes,
    )?.length
    const nTotalProccecedAnalytes = processedReport?.filter(
      (item) => item?.completedProcessComponents === true,
    )?.length

    if (nTotalProccecedAnalytes !== nTotalAnalytes) return

    try {
      ;(async () => {
        setBIsGeneratingPdf(true)
        const pdfBlob = await pdf(
          <CiqReportPdf
            generateReport={generetedReport}
            listAnalytes={processedReport}
          />,
        ).toBlob()

        const pdfUrl = URL.createObjectURL(pdfBlob)

        window.open(pdfUrl, "_blank")
        setIsLoadingGenerateReport(false)
      })()
    } catch (e) {
      toast({
        type: "error",
        description: intl.get("ciqReport.error_to_generate_pdf"),
      })
      setIsLoadingGenerateReport(false)
    }
  }, [generetedReport, processedReport, bIsGeneratingPdf])

  function dataTrintaDiasAtras() {
    const dataAtual = new Date() // Obtém a data atual
    dataAtual.setDate(dataAtual.getDate() - 30) // Subtrai 30 dias

    const ano = dataAtual.getFullYear()
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0") // Mês começa em 0, então somamos 1
    const dia = String(dataAtual.getDate()).padStart(2, "0") // Adiciona 0 à esquerda se necessário

    return `${ano}-${mes}-${dia}` // Retorna no formato ano-mês-dia
  }

  useEffect(() => {
    if (!oEquipmentSelected?.length) {
      setAnalytes([])
      setOAnalyteSelected([])
      return
    }

    ;(async function () {
      for await (const e of oEquipmentSelected) {
        await getAnalyteLinkedEquipment(e.value)
      }
    })()
  }, [oEquipmentSelected])

  useEffect(() => {
    getEquipments()

    setTimeout(() => {
      setABreadcrumb([
        {
          path: "./",
          name: intl.get("home"),
        },
        {
          path: "/ciq",
          name: intl.get("ciq.title"),
        },
        {
          path: "/ciq/generate-report",
          name: intl.get("ciq.generete_reports"),
          bActive: true,
        },
      ])
    }, 200)
  }, [])

  const fnHandleGenerateReport = async () => {
    if (endDate < startDate) {
      toast({
        type: "error",
        title: intl.get("table_fields.toast.fail"),
        description: intl.get(
          "ciq.release_details.date_filters.date_final_must_greater_than_or_equal_initial",
        ),
      })
      return
    }

    const handleStatus = status?.value ? { status: status?.value } : {}
    await getReport({
      equipments: oEquipmentSelected?.map((e) => e.value) || [],
      analytes: oAnalyteSelected?.map((e) => e.value) || [],
      start_date: startDate,
      end_date: endDate,
      ...handleStatus,
    })
  }

  return (
    <>
      <div>
        <RcmpHeader
          cTitlePage={intl.get("ciq.internal_control_quality")}
          elIcon={<IconCiq />}
          className={styles.header}
          aBreadCrumbs={aBreadcrumb}
        />
        <ContentBlank
          bShowFilter={false}
          bCanSearch={false}
          bSwitchable={false}
          bVisibleIconSearch={false}
          bArrowLeftGoBack={true}
          className={styles.contentBlankCustom}
          cLabelGoBack={intl.get("ciq.generete_reports")}
          cPathGoBack="/ciq"
        >
          {isLoading ? (
            <div className={styles.centerLoading}>
              <RcmpLoading bShow={true} size={50} />
            </div>
          ) : (
            <div className={styles.contentFilter}>
              <ReportFilters
                equipments={equipments}
                setOAnalyteSelected={setOAnalyteSelected}
                oAnalyteSelected={oAnalyteSelected}
                setOEquipmentSelected={setOEquipmentSelected}
                oEquipmentSelected={oEquipmentSelected}
                analytes={analytes}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                startDate={startDate}
                endDate={endDate}
                setStatus={setStatus}
                isLoadingAnalyte={isLoadingAnalyte}
              />

              <Button
                isLoading={isLoadingGenerateReport}
                onClick={fnHandleGenerateReport}
              >
                {intl.get("ciq.generete_reports")}
              </Button>
            </div>
          )}
        </ContentBlank>
      </div>
      {Object.prototype.hasOwnProperty.call(generetedReport, "filters") && (
        <>
          {generetedReport.equipment
            ?.flatMap((eqp) => eqp.equipment_analytes)
            .map((analyte, index) => (
              <ProcessChartAndTableToImage
                key={`chart-to-image-${index}`}
                analyte={analyte}
                processedReport={processedReport}
                setProcessedReport={setProcessedReport}
              />
            ))}
        </>
      )}
    </>
  )
}

export default Reports
